import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Button, Typography, Result } from "antd";
import Spinner from "../../../../common/components/spinner/Spinner";

import {
  getUserProfiles,
  setActiveProfile,
  setProfileMonitoring
} from "../../redux/actions/ProfileList";
import * as interfaceActions from "../../../../common/redux/actions/interfaceActions";
import * as URLs from "../../../../common/constants/systemUrls";
// import { API } from '../../../../common/api/constants';
import moment from "moment";
import { saveState } from "../../../../common/utils/localStorage";
import { Redirect } from "react-router-dom";

const { disableCaption } = interfaceActions;
const { Text } = Typography;

const ProfileList = props => {
  useEffect(() => {
    dispatch(disableCaption());
    dispatch(getUserProfiles());
  }, []);
  const profiles = useSelector(state => state.Authorization.profiles);
  const dispatch = useDispatch();
  const profilesList = profiles.profiles;
  const handleClickRow = profile => {
    return {
      onClick: () => {
        handleProfile(profile.profile);
      }
    };
  };
  function renderColumns() {
    return [
      {
        title: "ФИО",
        dataIndex: "profile",
        key: "user",
        render: profile => (
          <span>
            {profile.user.lastname || "–"}
            <br />
            <Text type="secondary">
              {`${profile.user.name || ""} ${profile.user.patronymic || ""}`}
            </Text>
          </span>
        )
      },
      {
        title: "Должность",
        dataIndex: "profile",
        key: "role",
        render: profile => (
          <span>
            {profile.role.role}
            <br />
            <Text type="secondary">
              {profile.company.subjectKey === "physical"
                ? "ФЛ, " +
                  (profile.company.userName ? profile.company.userName : "—")
                : profile.company.nameLegal
                ? profile.company.nameLegal
                : ""}
              <br />
              {profile.company.inn ? `ИНН ${profile.company.inn}` : ""}
            </Text>
          </span>
        )
      },
      {
        title: "Последний вход",
        dataIndex: "profile",
        key: "lastActivity",
        render: profile =>
          profile.lastActivity && (
            <React.Fragment>
              {moment(profile.lastActivity).fromNow()}
              <br />
              {moment(profile.lastActivity).format("DD.MM.YYYY")}
            </React.Fragment>
          )
      }
    ];
  }
  function handleProfile(profile) {
    saveState(
      {
        profileId: profile.id,
        nameLegal: profile.company.nameLegal,
        roleId: profile.role.roleId,
        role: profile.role.role,
        roleKey: profile.role.roleKey,
        companyId: profile.company.id,
        subjectId: profile.company.subjectId
      },
      "activeProfile"
    );
    dispatch(setProfileMonitoring(profile.id));
    dispatch(
      setActiveProfile({
        profileId: profile.id,
        nameLegal: profile.company.nameLegal,
        roleId: profile.role.roleId,
        role: profile.role.role,
        roleKey: profile.role.roleKey,
        companyId: profile.company.id,
        subjectId: profile.company.subjectId,
        redirect: true
      })
    );
  }

  return (
    <>
      {!profiles.loading && profilesList && profilesList.length > 0 ? (
        <div className="basicForm">
          <div className="profileListTable">
            <Table
              title={() => (
                <h2 style={{ textAlign: "center" }}>
                  Выберите профиль для входа
                </h2>
              )}
              // scroll={{ y: 240 }}
              pagination={{ pageSize: 5 }}
              locale={{
                emptyText: "У вас еще нет профилей! Добавьте профиль!"
              }}
              loading={profiles.loading}
              columns={renderColumns()}
              rowKey={profile => profile.profile.id}
              dataSource={profilesList || []}
              onRow={handleClickRow}
            />
          </div>
        </div>
      ) : profilesList && profilesList.length === 0 && !profiles.loading ? (
        <Redirect to={"/authorization/add/profile"} />
      ) : (
        <Spinner />
      )}
    </>
  );
};

export default ProfileList;
